import { cn } from '@/lib/cn';
import type { VariantProps } from 'class-variance-authority';
import { tagVariants } from './tag-variants';

export interface TagProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof tagVariants> {}

const Tag = ({ className, variant, ...props }: TagProps) => {
  return <div className={cn(tagVariants({ variant }), className)} {...props} />;
};

export default Tag;
